<template>
  <gj-modal
      :visible.sync="modalVisible"
      :destroyOnClose="true"
      :footer="false"
      size="normal"
      :loading="importHandleLoading"
      :loading-text="importHandleLoadingText">
    <template #header>
      <span>导入期初</span>
    </template>
    <template #content>
      <gj-upload
          class="upload-btn"
          template-url="/supply/productInventory/downloadProductCostTemplate"
          container-type="productInventory"
          @uploadAfter="uploadAfter">
        <template #tip>
          <span>只能上传xls/xlsx文件</span>
        </template>
      </gj-upload>
      <gj-import-alert
          :rules="[
            '支持导入格式为xls的文件',
            '模板中的表头不可更改、位置不能调换，不能删除',
            '仓库名称请严格遵守按仓库资料中的仓库名称填列',
            '当SKU出现重复，以第一条记录为准',
            '每次导入将更新一次已有记录'
          ]">
      </gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, uploadMixin} from "../../../../../minxins";
  import {importProductInventoryInitCost} from "../../../../../api/warehouse";

  export default {
    name: "app-product-inventory-import-modal",
    mixins: [modalMixIn, uploadMixin],
    data() {
      return {}
    },
    methods: {
      destroy() {
        this.$gjModal.$gjDestroy();
      },
      uploadAfter(attId, data, uploadCb) {
        this.importHandleLoading = true;
        importProductInventoryInitCost(attId)
          .then((res) => {
            this.$gjImportHandle(res, uploadCb);
          }).catch(() => {
            uploadCb('error')
          })
          .complete(() => this.importHandleLoading = false);
      }
    }
  }
</script>

<style scoped>
  .upload-btn {
    margin: 0 0 12px;
  }
</style>
